import { type FC } from 'react';
import cn from 'classnames';

import { H2, StringSmall } from '@/components/Typography/Typography';

import { SpinnerDots } from '../SpinnerDots/SpinnerDots';

interface WaitInfoProps {
  className?: string;
  title?: {
    text: string;
    className?: string;
  };
  additionalInfo?: {
    text: string;
    className?: string;
  };
  description?: {
    text: string;
    className?: string;
  };
}

const WaitInfo: FC<WaitInfoProps> = ({
  className,
  title,
  additionalInfo,
  description,
}) => {
  return (
    <div className={cn('flex flex-col items-center gap-8', className)}>
      <div className="flex flex-col items-center gap-2">
        {title && (
          <H2 weight="extrabold" className={title.className}>
            {title.text}
          </H2>
        )}
        {additionalInfo && (
          <StringSmall
            className={cn(
              '!text-white/60 !leading-1.3 text-center',
              additionalInfo.className,
            )}
          >
            {additionalInfo.text}
          </StringSmall>
        )}
      </div>
      <SpinnerDots />
      {description && (
        <StringSmall
          className={cn(
            '!text-white/60 !leading-1.3 text-center',
            description.className,
          )}
        >
          {description.text}
        </StringSmall>
      )}
    </div>
  );
};

export { WaitInfo };
